import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
// This Module's Components
import { MyTripsConfirmationNoComponent } from './mytrips-confirmation-no.component';

@NgModule({
  imports: [CommonModule, HttpClientModule, ModalModule.forRoot()],
  declarations: [MyTripsConfirmationNoComponent],
  exports: [MyTripsConfirmationNoComponent]
})
export class MyTripsConfirmationNosModule {}
